import * as React from "react";

import "./LegendTooltip.scss";

export interface LegendTooltipConfig {
    visible: boolean;
    offSetX?: number;
    offSetY?: number;
    width?: number;
    height?: number;
    data?: any;
    father?: HTMLElement;
}

interface LegendTooltipConfigProps {
    config: LegendTooltipConfig;
    className?: string;
    style?: React.CSSProperties;
}

interface LegendTooltipConfigState {
    visible: boolean;
    isFatherHovered: boolean;
}

export class LegendTooltip extends React.Component<LegendTooltipConfigProps, LegendTooltipConfigState> {

    constructor(props) {
        super(props);
        this.state = {visible: this.props.config.visible, isFatherHovered: this.props.config.visible};
    }

    public render() {
        const children = this.props.children as (...args: any) => any;
        if (this.props.config.father) {
            this.props.config.father.onmouseleave = (e) => {
                this.setState({isFatherHovered: false});
            };

            this.props.config.father.onmouseenter = (e) => {
                this.setState({isFatherHovered: true});
            };
        }

        return this.state.visible || this.state.isFatherHovered ? (
            <div
                style={{
                    position: "absolute",
                    width: this.props.config.width,
                    height: this.props.config.height,
                    left: this.props.config.offSetX,
                    top: this.props.config.offSetY,
                    backgroundColor: "#fff",
                    zIndex: 10000,
                    textAlign: "initial",
                    ...this.props.style,
                }}
                className={this.props.className}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {children && this.props.config.data ? children(this.props.config.data) : null}
            </div>
        ) : null;
    }

    private onMouseEnter = () => {
        this.setState({visible: true});
    }
    private onMouseLeave = () => {
        this.setState({visible: false});
    }
}
